import type { TaskFeedFetcher } from '@/modules/tasks-list/domain/task-feed/TaskFeedFetcher';
import { TaskFeed } from '@/modules/tasks-list/domain/task-feed/TaskFeed';
import { inject, injectable } from 'tsyringe';
import { TaskEntityManagerToken } from '@/modules/tasks-list/di/tokens';
import type { TaskEntityManager } from '@/modules/tasks-list/domain/task-feed/TaskEntityManager';
import { FilteredInboxTaskRepository } from '@/modules/tasks-list/domain/task-feed/FilteredInboxTaskRepository';

@injectable()
export class InboxTaskFeedFetcher implements TaskFeedFetcher {
  constructor(
    @inject(TaskEntityManagerToken)
    private readonly taskEntityManager: TaskEntityManager,
    private readonly filteredInboxTaskRepository: FilteredInboxTaskRepository,
  ) {}

  async fetch(): Promise<TaskFeed> {
    const tasks = await this.filteredInboxTaskRepository.getFilteredInbox();

    const ids = await this.taskEntityManager.storeEntities(tasks);

    return new TaskFeed(ids);
  }
}
